<template>
<div style="background-color: #43a047;">
  <div class="container">
    <div class="b_contain" id="containLoader">
      <div class="sign-up-conatiner">
        <div class="welcome">
          <router-link class="navbar-brand" :to="{ name: 'Home' }">
          <img
            class="welcome-img"
            style=""
            alt="Secc logo"
            src="../../assets/secclogo.png"
          />
          </router-link>
          <h3 class="welcome-title">Welcome to Our Training</h3>
          <p class="welcome-proword">To Keep Connection to our Training</p>
        </div>
        
        <div class="sign-up-form"  v-if="forgetpassword.setScreen==0">
        <form v-on:submit.prevent class="frmSignin">
          <div class="mb-3" style="">
            <h3>Forget Password?</h3>
            <p>Enter your register email address to reset password</p>
          </div>
          <div class="mb-3">
            <label for="exampleInputEmail1" class="form-label"
              >Email address:</label
            >
            <input
              type="text"
              v-model="forgetpassword.email"
              :class="{ 'is-invalid': v$.forgetpassword.email.$error }"
              class="form-control"
            />
          </div>
          <div style="text-align:center;">
            <button
              type="buttom"
              class="btn btn-primary" style="width:100%"
              @click="sendemail"
            >
              Reset Password <i class="fas fa-sign-in-alt"></i>
            </button>
            
          </div>
          <div class="mt-3 mb-3 form-check text-center">Don't have an account?  <router-link style="color:#fff;" :to="{ name: 'SystemLogin' }"
              >Sign In</router-link
            ></div>
          
        </form>
        </div>
        <div class="sign-up-form"  v-else-if="forgetpassword.setScreen==1">
          <form v-on:submit.prevent class="frmSignin">
            <div class="mb-3 icon-edu" style="">
              <h3>Forget Password?</h3>
            </div>
            <div class="mb-3">
              <label for="exampleInputEmail1" class="form-label"
                >Please check your email and enter your confirmation code:</label
              >
              <input
                v-model="confirm.otp"
                type="text"
                style="text-align:center;"
                :class="{ 'is-invalid': v$.confirm.otp.$error }"
                class="form-control"
              />
            </div>
            <div style="text-align:center;">
              <button
                type="buttom"
                @click="confirmCode"
                class="btn btn-primary" style="width:100%"
              >
                Confirm <i class="fas fa-sign-in-alt"></i>
              </button>
            </div>
            <div class="mt-3 mb-3 form-check text-center">
              Don't you get confirmation code?  
              <a href="#" style="color:#0d6efd;" @click.prevent="sendemail"
                >Resend</a> <br>Or go to  
              <router-link style="color:#f8e004;" :to="{ name: 'SystemLogin' }"
                >Signin</router-link>
            </div>
          </form>
        </div>
        <div class="sign-up-form" v-else-if="forgetpassword.setScreen==2 && forgetpassword.isverify">
            <form v-on:submit.prevent class="frmSignin">
              <div class="mb-3 icon-edu" style="">
                <h3>Reset your password?</h3>
              
              </div>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label"
                  >New Password:</label
                >
                <input
                  type="password"
                  v-model="reset.password"
                  :class="{ 'is-invalid': v$.reset.password.$error }"
                  class="form-control"
                />
              </div>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label"
                  >Conform Password:</label
                >
                <input
                  type="password"
                  v-model="reset.password_confirmation"
                 :class="{ 'is-invalid': v$.reset.password_confirmation.$error }"
                  class="form-control"
                />
              </div>
              <div style="text-align:center;">
                <button
                  type="buttom"
                  class="btn btn-primary" style="width:100%"
                  @click="resetpassword"
                >
                  Reset <i class="fas fa-sign-in-alt"></i>
                </button>
              
              </div>
              <div class="mt-3 mb-3 form-check text-center">
                Go to  
                <router-link style="color:#f8e004;" :to="{ name: 'SystemLogin' }"
                  >Singin</router-link>
              </div>
            
            </form>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import axios from "@/axios";
import useVuelidate from "@vuelidate/core";
import { required, email ,sameAs } from "@vuelidate/validators";

export default {
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      forgetpassword: {
        email: "",
        isverify: true,
        setScreen: 0,
      },
      confirm:{
        otp: "",
      },
      reset:{
        password:'',
        password_confirmation:'',
      }
    };
  },
  validations() {
    return {
      forgetpassword: {
        email: { required, email, $autoDirty: true },
      },
      confirm: {
        otp: { required, $autoDirty: true },
      },
      reset: {
        password: { required, $autoDirty: true },
        password_confirmation: {
          required,
          sameAsPassword: sameAs(this.reset.password),
          $autoDirty: true
        }
      }
    };
  },
  methods: {
    showLoader() {
      return this.$loading.show({
        // Optional parameters
        container: this.$refs.containLoader,
        color: "#01B201",
        canCancel: true,
        onCancel: this.onCancelLoader
      });
    },
    async sendemail(){
      //this.v$.$validate(); // checks all inputs
      this.v$.forgetpassword.$touch();
      if (!this.v$.forgetpassword.email.$invalid){
        let loader = this.showLoader();
        try {
          let response = await axios.post("sent-reset-password"
            , {email: this.forgetpassword.email}
          );
          this.$toast.open({
                message: response.data.message,
                type: "success",
                duration: 5000,
                dismissible: true,
                position: "top-right"
              });
          loader.hide();
          this.forgetpassword.setScreen = 1;
        } catch (error) {
          this.$toast.open({
                message: error.response.data.message,
                type: "error",
                duration: 5000,
                dismissible: true,
                position: "top-right"
              });
          loader.hide();
        }
      }
    },
    async confirmCode(){
      this.v$.confirm.$touch();
      if (!this.v$.confirm.$invalid) {
        let loader = this.showLoader();
        try {
          let response = await axios.post("verify-opt-code"
            , {
              email: this.forgetpassword.email,
              otp: this.confirm.otp
              }
          );
          this.$toast.open({
                message: response.data.message,
                type: "success",
                duration: 5000,
                dismissible: true,
                position: "top-right"
              });
          loader.hide();
          this.forgetpassword.setScreen = 2;
          this.forgetpassword.isverify = true;
        } catch (error) {
          this.$toast.open({
                message: error.response.data.message,
                type: "error",
                duration: 5000,
                dismissible: true,
                position: "top-right"
              });
          loader.hide();
        }
      }
    },
    async resetpassword(){
      this.v$.reset.$touch();
      if (!this.v$.reset.$invalid) {
        let loader = this.showLoader();
        try {
          let response = await axios.post("save-reset-password"
            , {
                email: this.forgetpassword.email,
                otp: this.confirm.otp,
                password: this.reset.password,
                password_confirmation: this.reset.password_confirmation
              }
          );
          this.$toast.open({
                message: response.data.message,
                type: "success",
                duration: 5000,
                dismissible: true,
                position: "top-right"
              });
          loader.hide();
          this.forgetpassword.setScreen = 0;
          this.forgetpassword.isverify = false;
          this.$router.push({ name: "SystemLogin" });

        } catch (error) {
          this.$toast.open({
                message: error.response.data.message,
                type: "error",
                duration: 5000,
                dismissible: true,
                position: "top-right"
              });
          this.forgetpassword.setScreen = 0;
          this.forgetpassword.isverify = false;
          loader.hide();
          this.$router.push({ name: "ForgetPassword" });
        }
      }
    }
  }
};
</script>

<style scoped>
.b_contain {
  display: flex;
  height: 100vh !important;
  width: 100%;
  align-items: center;
  justify-content: center;
  font-family: 14px;
}
.sign-up-conatiner {
  width: 100%;
  display: flex;
  background-color: #43a047;
  border-radius: 12px;
  box-shadow: blue;
  color: #fff;
  margin-top: 20px;
  height: 90%;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.welcome {
  background-color: #2e7d32;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 50px 20px;
  align-items: center;
  justify-content: center;
}
.sign-up-form {
  /* background-color: coral; */
  display: flex;
  flex: 2;
  padding: 20px;
  justify-content: center;
  align-items: center;
}
.width-bottom {
  width: 80%;
}
.welcome-img {
  width: 132px;
  margin-bottom: 22px;
}
.welcome-title {
  padding: 5px;
  font-size: 22px;
  text-align: center;
}
.welcome-proword {
  padding: 5px;
  text-align: center;
}
.icon-edu {
  margin-bottom: 25px !important;
  text-align: center;
}
@media (max-width: 774px) {
  .b_contain {
    height: auto;
  }
  .welcome {
    padding: 0;
  }
  .welcome-title {
    padding: 2px;
    font-size: 16px;
    margin-bottom: 0;
  }
  .welcome-proword {
    padding: 0px;
  }
  .sign-up-conatiner {
    flex-direction: column;
    width: 100%;
  }
  .welcome-img {
    width: 90px;
    margin-bottom: 0;
  }
  .icon-edu {
    display: none;
  }
  .frmSignin{
    width: 350px;
  }
}
</style>
